module.exports = __webpack_public_path__ + "static/prismic-065c23d6b873ad51d8c81eb93204ae0c.svg";